// app/javascript/controllers/base_dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Common targets that child controllers are expected to have.
  static targets = ["dropdownToggle", "applyBtn", "countDisplay"]

  connect() {
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this)

    // Listen for clicks on the whole document to detect outside clicks.
    document.addEventListener('click', this.boundHandleOutsideClick)

    // Prevent the dropdown from closing when clicking inside its menu.
    const dropdownMenu = this.element.querySelector('.dropdown-menu')
    if (dropdownMenu) {
      dropdownMenu.addEventListener('click', (e) => e.stopPropagation())
    }
  }

  disconnect() {
    // Clean up event listeners when the controller is disconnected.
    document.removeEventListener('click', this.boundHandleOutsideClick)
  }

  
  
  /**
   * Closes the dropdown if a click occurs outside of its element.
   */
  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.closeDropdown()
    }
  }

  /**
   * Closes the dropdown using Bootstrap's API.
   */
  closeDropdown() {
    if (this.hasDropdownToggleTarget) {
      const toggleButton = this.dropdownToggleTarget
      const dropdown = bootstrap.Dropdown.getInstance(toggleButton) || new bootstrap.Dropdown(toggleButton)
      dropdown.hide()
      // Remove focus so the button reverts to its non-active style
      toggleButton.blur()
    }
  }

  closeOffcanvas() {
    const offcanvasElement = document.getElementById('offcanvasFilters')
    if (offcanvasElement) {
      const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement)
      if (offcanvas) {
        offcanvas.hide()
      }
    }
  }

  /**
   * Submits the main auction filter form.
   */
  submitSharedForm() {
    const form = document.getElementById('auction-filters-form')
    if (form) {
      form.requestSubmit()
    }
  }

  /**
   * This method must be implemented by any controller that inherits from this base controller.
   */
  applyFilters() {
    throw new Error("The 'applyFilters' method must be implemented by the subclass.")
  }
}
